import React, { useEffect, useMemo, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";
import i18n from "../i18n";

const logos = [
  { src: "vgkk.png" },
  { src: "gkk.png" },
  { src: "wiener.png" },
  { src: "porr.png" },
  { src: "pv.png" },
  { src: "ober.png" },
  { src: "tirol.png" },
  { src: "lv1871.png" },
  { src: "sv.png" },
  { src: "csc.png" },
  { src: "linz.png" },
  { src: "brz.png" },
  { src: "no.png" },
  { src: "post.png" },
  { src: "generali.png" },
  { src: "oracle.png" },
  { src: "mmkarton.png" },
  { src: "justiz.png" },
  { src: "svs.png" },
  { src: "burgenland.png" }
];

const Clients = () => {
  const [langTick, setLangTick] = useState(0);

  useEffect(() => {
    const onLang = () => setLangTick((x) => x + 1);
    i18n.on("languageChanged", onLang);
    return () => i18n.off("languageChanged", onLang);
  }, []);

  const tr = useMemo(() => {
    void langTick;
    return {
      title: i18n.t("clients.title"),
      line1: i18n.t("clients.text.line1"),
      line2: i18n.t("clients.text.line2")
    };
  }, [langTick]);

  return (
    <section className="relative bg-gradient-to-b from-[#050825] to-[#060A40] text-white py-20 px-4 text-center overflow-hidden">
      <h2 className="text-3xl md:text-4xl font-semibold mb-4">{tr.title}</h2>

      <p className="text-sm md:text-base max-w-xl mx-auto text-gray-300 mb-12 leading-relaxed">
        {tr.line1} <br />
        {tr.line2}
      </p>

      <div className="relative max-w-6xl mx-auto overflow-hidden">
        <div className="absolute top-0 left-0 w-10 md:w-20 h-full z-10 pointer-events-none bg-gradient-to-r from-[#050825] to-transparent" />
        <div className="absolute top-0 right-0 w-10 md:w-20 h-full z-10 pointer-events-none bg-gradient-to-l from-[#050825] to-transparent" />

        <div className="hidden md:grid grid-cols-10 gap-6">
          {logos.map((logo, index) => (
            <div
              key={index}
              className="bg-white rounded-xl w-full aspect-square flex items-center justify-center p-4 shadow-md transition-transform hover:scale-105"
            >
              <img
                src={`${process.env.PUBLIC_URL}/logos/${logo.src}`}
                alt={logo.src.replace(".png", "")}
                className="max-h-full max-w-full object-contain"
              />
            </div>
          ))}
        </div>

        <div className="md:hidden">
          <Swiper
            modules={[Autoplay]}
            autoplay={{
              delay: 1,
              disableOnInteraction: false
            }}
            loop={true}
            loopedSlides={logos.length}
            speed={3000}
            spaceBetween={12}
            breakpoints={{
              0: { slidesPerView: 4 },
              768: { slidesPerView: 6 }
            }}
          >
            {logos.map((logo, index) => (
              <SwiperSlide key={index}>
                <div className="bg-white rounded-xl w-full aspect-square flex items-center justify-center p-3 shadow-md transition-transform hover:scale-105">
                  <img
                    src={`${process.env.PUBLIC_URL}/logos/${logo.src}`}
                    alt={logo.src.replace(".png", "")}
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Clients;









